//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import GetCouponData from '~/mixins/coupon/get-coupon-data'
import GAEcommerce from '~/mixins/ga-ecommerce'

export default {
  mixins: [
    GetCouponData,
    GAEcommerce
  ],
  props: {
    showPromoCode: {
      type: Boolean,
      default: false
    },
    showQuarterlySelect: {
      type: Boolean,
      default: true
    },
    showRemoveButton: {
      type: Boolean,
      default: true
    },
    showEstimatedArrival: {
      type: Boolean,
      default: false
    },
    isB2bOrder: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      couponCodeValue: ''
    }
  },
  computed: {
    ...mapState('product', ['areaPrice', 'planSelected', 'areaPrice', 'mainArea', 'otherAreas', 'fastTrack', 'isGift', 'fastTrackTests', 'couponCode', 'starterTest', 'improvementProgramPrice', 'planPrice', 'baseCompleteTests']),
    ...mapState('quiz', ['goalName']),
    ...mapGetters({
      getSubTotalPrice: 'product/getSubTotalPrice',
      getTotalPrice: 'product/getTotalPrice',
      getTotalPriceWithDiscount: 'product/getTotalPriceWithDiscount',
      getDiscount: 'product/getDiscount',
      getPlanPriceFull: 'product/getPlanPriceFull',
      getPlanPriceRaw: 'product/getPlanPriceRaw',
      getPlanPrice: 'product/getPlanPrice',
      isQuizPlanResults: 'product/isQuizPlanResults',
      isBaseImprovementPlan: 'product/isBaseImprovementPlan',
      isBaseCompletePlan: 'product/isBaseCompletePlan',
      isBaseCompleteResultsPlan: 'product/isBaseCompleteResultsPlan',
      isBaseCompleteImprovementPlan: 'product/isBaseCompleteImprovementPlan',
      isBaseCompleteImprovementPlanPayUpfront: 'product/isBaseCompleteImprovementPlanPayUpfront',
      getPriceWithoutImprovementProgram: 'product/getPriceWithoutImprovementProgram'
    }),
    mainProductTitle () {
      return this.getAreaProductTitle(this.mainArea)
    },
    mainProductCaption () {
      const planSelected = this.isGift && (!this.isBaseCompleteResultsPlan && !this.isBaseCompletePlan && !this.isBaseCompleteImprovementPlan) ? 'gift' : this.planSelected
      return this.$t(`general.orderSummary.body.productSelectedCaption.${planSelected}`, { firstTest: this.starterTest })
    },
    productFastTrackTitle () {
      return this.$t(`general.orderSummary.body.productSelectedFastTrack.${this.planSelected}`, { area: this.mainArea })
    },
    tests () {
      return this.$t('general.orderSummary.body.improvementProgramPayUpfront.included')
    },
    showShipsAfterModule () {
      return !this.isGift && (this.mainArea || this.isBaseCompleteResultsPlan || this.isBaseCompleteImprovementPlan)
    }
  },
  mounted () {
    this.applyRCCodeIfExists()
  },
  methods: {
    getAreaProductTitle (area) {
      let title = this.$t(`general.orderSummary.body.productSelected.${this.planSelected}`, { area })
      if (this.isGift) {
        title = title.replace('monitor', ' Gift')
      }
      return title
    },
    removeMainArea () {
      this.addDDAction('Remove area button clicked', {
        path: this.$route.path,
        section: 'cart',
        area: this.mainArea
      })
      this.trackGAEcommerceRemoveFromCart({ area: this.mainArea, plan: this.planSelected })
      this.$store.dispatch('product/removeMainArea')
    },
    async applyRCCodeIfExists () {
      const couponCode = sessionStorage.getItem('rc')
      if (couponCode) {
        const couponData = await this.getCouponData(couponCode)
        if (couponData.active) {
          this.$store.dispatch('product/setCouponCodeData', { ...couponData, name: couponCode })
        }
      }
    },
    async applyDiscount () {
      const couponCode = this.couponCodeValue.toUpperCase()
      const couponData = await this.getCouponData(couponCode)
      if (couponData) {
        this.$store.dispatch('product/setCouponCodeData', { ...couponData, name: couponCode })
      }
    }
  }
}
